const startPage = {
  text: 'Disclaimer',
  value: 'start-page'
};

export default startPage;
